
export const header = {
    home:'首页',
    product:'产品',
    case:'案例',
    about:'关于铁辰',
    system:'系统入口',
}
export const footer = {
    companyName:'南京铁辰安全技术有限公司',
    mobilePhone:'手机：17384461558（冷经理）',
    telephone:'电话：025-52211001',
    email:'邮箱：lengyanfei@techin-aiot.com',
    address:'地址：南京市雨花台区郁金香路吉美思大厦B座303室',
    miniPro:'扫码关注铁辰小程序',
    app:'扫码下载铁辰App'
}
// 首页
export const home = {
    welcome:'欢迎来到铁辰科技',
    bannerWords:'我们在消防工程、维保、智能化业务基础上，主攻IT、物联网、大数据、AI方向，拓展智慧消防、安防领域，自主研发了智慧消防、智慧安防、智慧用电、智能烟感、视频RTC、AI视频识别等多个产品，广泛应用于多家单位，多次获得铁路局科技进步等奖项。',
    aboutBtn:'关于我们',
    contactBtn:'联系我们'
}
